import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { KeycloakService } from '../../../../../usermgmt/src/public-api';
import { AppStateService } from 'usermgmt';

@Injectable({
    providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
    constructor(
        private keycloak: KeycloakService,
        private appStateSrv: AppStateService
    ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const customerUuid = this.appStateSrv.getCurrentCustomerId();
        let modifiedRequest = request;
        if (customerUuid) {
            modifiedRequest = request.clone({ headers: request.headers.set('customer-uuid', customerUuid) });
        }

        return next.handle(modifiedRequest).pipe(tap({
            next: (res: any) => {
                // do anything with the response if necessary
            }, error: async (error) => {
                if (error instanceof HttpErrorResponse) {
                    if (error.status === 401) {
                        this.keycloak.logout();
                        return
                    } else {
                        // const errorMessage = this.setError(error);
                        return;
                    }
                } else {
                    return;
                }
            }
        }));
    }
}
